import { Helmet } from "react-helmet";

const Meta = () => {
  return (
    <Helmet>
      <title>Randi - Takk for at du meldte deg på!</title>
      <meta name="thumbnail" content="https://randi.ai/showcase.jpg" />
      <meta name="robots" content="index, follow" />
      <meta
        name="description"
        content="Du vil nå motta en epost som bekrefter at du er påmeldt, og vil få tilsendt alt du trenger av informasjon når webinaret nærmer seg!"
      />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:url" content="https://randi.ai/" />
      <meta
        name="twitter:title"
        content="Randi - Takk for at du meldte deg på!"
      />
      <meta
        name="twitter:description"
        content="Du vil nå motta en epost som bekrefter at du er påmeldt, og vil få tilsendt alt du trenger av informasjon når webinaret nærmer seg!"
      />
      <meta name="twitter:image" content="https://randi.ai/showcase.jpg" />

      <meta property="og:url" content="https://randi.ai/" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Randi - Takk for at du meldte deg på!"
      />
      <meta
        property="og:description"
        content="Du vil nå motta en epost som bekrefter at du er påmeldt, og vil få tilsendt alt du trenger av informasjon når webinaret nærmer seg!"
      />
      <meta property="og:image" content="https://randi.ai/showcase.jpg" />
      <link rel="canonical" href="https://randi.ai/" />
    </Helmet>
  );
};

export default Meta;
